import sectionsService from '../services/SectionsService'

const sectionsStore = {
  namespaced: true,
  state: {
    sections: [],
    selectedSection: null
  },
  mutations: {
    setSections: (state, sections) => {
      Object.assign(state.sections, sections)
    },
    addSection: (state, section) => {
      state.sections.unshift(section)
    },
    delete: (state, id) => {
      state.sections = state.sections.filter(item => item.id !== id)
    },
    selectSection: (state, section) => {
      state.selectedSection = section
    },
    clearSelected: state => {
      state.selectedSection = null
    },
    updateStateSection: (state, section) => {
      // in order to update a section, just send on the object the propertis you want to change:
      // example: to change the status and priority, send an object like this { status: 'pending'. priority: 4 }
      state.sections.map(item => {
        if (item.id === section.id) Object.assign(item.data, section.data)
      })
    }
  },
  actions: {
    list: async ({ commit }, currentUserId) => {
      let sections = await sectionsService.list(currentUserId)
      if (!sections.empty) {
        sections = sections.docs.map((item) => {
          return {
            id: item.id,
            ...item.data()
          }
        })
      }
      commit('setSections', sections)
    },
    addToList: ({ commit }, section) => {
      commit('addSection', section)
    },
    get: ({ commit }, item) => {
      commit('selectSection', item)
    },
    delete: async ({ commit }, id) => {
      await sectionsService.delete(id)
      commit('delete', id)
    },
    clear: ({ commit }) => {
      commit('clearSelected')
    },
    create: async ({ dispatch, commit }, section) => {
      const response = await sectionsService.create(section)
      if (response) dispatch('addToList', response)
      return response
    },
    update: async ({ dispatch, commit }, section) => {
      console.log(section)
      // const response = await sectionsService.update(section)
      // console.log(response)
    }
  },
  getters: {
    selectedSection: state => state.selectedSection,
    listSections: state => state.sections
  }
}

export default sectionsStore
